const contentDiv = document.querySelector('.accordion-details_content');

if (contentDiv) { // Check if the element was actually found
    const content = contentDiv.textContent?.trim() ?? "";
    if (content.length === 0) {
        contentDiv.style.display = 'none';
    }
} else {
    console.error("Error: Element with class 'accordion-details_content' not found.");
}
